import React, { useContext, useState} from "react";
import { PeFilterContext, ReCompaniesMaxDealOptions, ReCompaniesMinDealOptions } from "../../Contexts/PeFilterContext";
import SectorFilter from "../../Components/RefineSearchComponents/FundSector";
import TypeFilter from "../../Components/RefineSearchComponents/ReTypeFilter";
import RegionFilter from "../../Components/RefineSearchComponents/RegionFilter";
import CityFilter from "../../Components/RefineSearchComponents/CityFilter";
// import DealRangeFilter from "../../Components/RefineSearchComponents/DealRangeFilter";
import ExitStatusFilter from "../../Components/RefineSearchComponents/ExitStatusFilter";
import { useLocation, useMatch, useNavigate } from "react-router";
import routePathSegments, { routeNames } from "../../routeSegments";
import { useEffect } from "react";
import axios from "axios";
import { filterLocationUrl} from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import AcquirerDealRangeFilter from "../RefineSearchComponents/AcquirerDealRangeFilter";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import Subsectors from "../RefineSearchComponents/Subsectors";

// const InvestorDealRangeFilter = React.lazy(() => import("../RefineSearchComponents/InvestorDealRangeFilter"));


/**
 * The function `ReExitRefineSearch` is a React component that renders a form for refining search
 * filters in a specific context.
 * @returns a JSX element, which represents the UI of the component.
 */
export default function ReExitRefineSearch({ customPathname, menu, generalPathname }) {
    const {        
        onErrorHandler,dropdown,dbDropdown,setDbDropdown,SubSectorOptions, setSubSectorOptions,
        refineSearchFilters,SwitchState,setSwitchState,
        InvestorOptions , setInvestorOptions ,
        lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions , TargetCompanyOptions , setTargetCompanyOptions ,
        setrefineSearchFilters, setMonthPickerValue } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(32);
    const navigate = useNavigate();
    const { getToken } = useContext(UserContext);    
    const location = useLocation();
    const {pathname} = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false

    //local updated options
    const [SectorOptions, setSectorOptions] = useState([])
    const [TypeOption, setTypeOption] = useState([]);
    const [RegionOptions, setRegionOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [MinDealRangeOptions, setMinDealRangeOptions] = useState([])
    const [MaxDealRangeOptions, setMaxDealRangeOptions] = useState([])
    const [ExitStatusOptions, setExitStatusOptions] = useState([])
    const [CountryOptions, setCountryOptions] = useState([])
    // const [SubSectorOptions, setSubSectorOptions] = useState([])


   /**
    * The function `applyFilter` updates the refine search filters based on the selected options.
    */
    const applyFilter = () => {
        const selectedFundSector = SectorOptions.filter(option => option.isChecked);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedType = TypeOption?.filter(option => option.isChecked);
        const selectedExitStatus = ExitStatusOptions?.filter(option => option.isChecked);
        const minDealRange = MinDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const maxDealRange = MaxDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedOperators = SwitchState;
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedInvestor = InvestorOptions?.filter(option => option.isChecked); 
        const selectedSubsector = SubSectorOptions?.filter(option => option.isChecked);

        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                fundSector: selectedFundSector,
                subSector: selectedSubsector,
                region: selectedRegion,
                city: selectedCity,
                type: selectedType,
                exitStatus: selectedExitStatus,
                dealRange: minDealRange != null && maxDealRange != null ? [minDealRange, maxDealRange] : [],
            },
            [customPathname]: {
                ...prev[customPathname],
                deals_operator : selectedOperators,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                investor_id : selectedInvestor ,
                target_company:selectedTargetCompany,
            },
        }))
    }

    /**
     * The function `resetFilter` resets a specific filter in the `refineSearchFilters` object by
     * setting its value to an empty object.
     */
    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {}
        }))
        setSubSectorOptions([]);
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setTargetCompanyOptions([]);
        setInvestorOptions([]);
    }


    // console.log('refineSearchFilters[refineSearchFilters]', refineSearchFilters[customPathname]);


    // Submitting Refine Search Form 

   /**
    * The function `refineSearchFilter` is used to refine search filters, reset certain values, and
    * navigate to a custom pathname if necessary.
    * @param event - The event parameter is an object that represents the event that triggered the
    * function. It contains information about the event, such as the type of event, the target element,
    * and any additional data associated with the event. In this case, it is used to prevent the
    * default behavior of the event (e.g
    */
    const refineSearchFilter = (event) => {
        event.preventDefault();
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        setCurrentPage(1);
        applyFilter();
        setSelected(false)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }


    /**
     * The `onResetClick` function resets the current page, filters, and navigates to a custom pathname
     * if it is not already on that pathname.
     * @param event - The event parameter is an object that represents the event that triggered the
     * function. In this case, it is likely a click event on a reset button.
     */
    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);      
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

   /**
    * The function `accordionClick` sets the selected value to either 0 or the provided value.
    * @param val - The `val` parameter is a value that is passed to the `accordionClick` function. It
    * is used to determine whether the accordion should be selected or deselected.
    */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

  /**
   * The function `onRegionChange` takes in an array of options, filters the options based on a
   * condition, maps the filtered options to extract specific properties, and then makes a POST request
   * to a specified URL with the extracted properties as parameters.
   * @param options - The `options` parameter is an array of objects. Each object represents an
   * industry and has the following properties:
   */
    const onRegionChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: ids,
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    useEffect(() => {
        const ids = refineSearchFilters[generalPathname]?.region?.map(value => value.id) ?? [];
        const cityIds = refineSearchFilters[generalPathname]?.city?.map(value => value.id) ?? [];
        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
                setCityOptions(response.data.city?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters])

    const toggleSwitchState = () => {
        setSwitchState(prevState => prevState === "and" ? "or" : "and");
    };

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    // Helper functions to count applied filters for each section
    const getTargetFiltersCount = () => {
        let count = 0;
        if (RegionOptions?.filter(option => option.isChecked).length > 0) count++;
        if (CityOptions?.filter(option => option.isChecked).length > 0) count++;
        if (TypeOption?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    const getDealFiltersCount = () => {
        let count = 0;
        if (MinDealRangeOptions?.filter(option => option.isChecked).length > 0) count++;
        if (SectorOptions?.filter(option => option.isChecked).length > 0) count++;
        if (SubSectorOptions?.filter(option => option.isChecked).length > 0) count++;
        if (ExitStatusOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (InvestorOptions?.filter(option => option.isChecked).length > 0) count++;
        if (TargetCompanyOptions?.filter(option => option.isChecked).length > 0) count++;
        if (lAdvisorsOptions?.filter(option => option.isChecked).length > 0) count++;
        if (tAdvisorsOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    console.log(refineSearchFilters, "refineSearchFilters");

    return (
        <div className="bg-white">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="min-h-full w-full flex flex-col">
                    <main className="flex-1 w-full py-4 overflow-y-auto">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4">
                            {/* Left column - Section Headers */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap md:mt-4">

                                {/* Keyword Search Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                        {getKeywordFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getKeywordFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                                {/* Deal Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Deal</span>
                                        {getDealFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getDealFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                                {/* Company Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'target' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'target' ? null : 'target')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Company</span>
                                        {getTargetFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'target' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getTargetFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'target' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                            </div>
                            
                            {/* Right column - Filter Options */}
                            <div className="overflow-visible mt-4 md:mt-0 pb-20 md:pb-0 md:col-span-6">
                                {/* Company Section Content */}
                                {activeFilterSection === 'target' && (
                                    <div className="grid grid-cols-1 sm:grid-cols-2  gap-4 gap-y-4 md:gap-8 md:gap-y-8 mt-4">
                                        <RegionFilter
                                            RegionOptions={RegionOptions}
                                            setRegionOptions={setRegionOptions}
                                            customPathname={generalPathname}
                                            onChange={onRegionChange}
                                            isPopupOpen={openFilterPopup === 'region'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'region' : null)}
                                        />
                                        <CityFilter
                                            CityOptions={CityOptions}
                                            setCityOptions={setCityOptions}
                                            customPathname={generalPathname}
                                            isPopupOpen={openFilterPopup === 'city'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)}
                                        />
                                        <TypeFilter
                                            TypeOption={TypeOption}
                                            setTypeOption={setTypeOption}
                                            customPathname={generalPathname}
                                            dataPath="re_exits"
                                            accordionClick={() => accordionClick(300)}
                                            open={select === 300} 
                                        />
                                    </div>
                                )}

                                {/* Deal Section Content */}
                                {activeFilterSection === 'deal' && (
                                    <div className="grid grid-cols-1 sm:grid-cols-2  gap-4 gap-y-4 md:gap-8 md:gap-y-8 mt-4">
                                        <AcquirerDealRangeFilter
                                            MaxDealOptions={MaxDealRangeOptions}
                                            setMaxDealOptions={setMaxDealRangeOptions}
                                            MinDealOptions={MinDealRangeOptions}
                                            setMinDealOptions={setMinDealRangeOptions}
                                            MaxDealrange={ReCompaniesMaxDealOptions}
                                            MinDealRange={ReCompaniesMinDealOptions}
                                            label="Deal Range (US $M)"
                                            customPathname={generalPathname}
                                            isPopupOpen={openFilterPopup === 'dealRange'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealRange' : null)}
                                        />
                                        <SectorFilter
                                            fundSectorOptions={SectorOptions}
                                            setFundSectorOptions={setSectorOptions}
                                            customPathname={generalPathname}
                                            onChange={() => {}}
                                            isPopupOpen={openFilterPopup === 'sector'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)}
                                        />
                                        <Subsectors 
                                            options={SubSectorOptions}
                                            setOptions={setSubSectorOptions}
                                            customPathname={generalPathname}
                                            label="Subsector"
                                        />
                                        <ExitStatusFilter
                                            ExitStatusOptions={ExitStatusOptions}
                                            setExitStatusOptions={setExitStatusOptions}
                                            customPathname={generalPathname}
                                            dataPath="exits"
                                            isPopupOpen={openFilterPopup === 'exitStatus'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'exitStatus' : null)}
                                        />
                                    </div>
                                )}

                                {/* Keyword Search Section Content */}
                                {activeFilterSection === 'keyword' && (
                                    <div className="w-full md:w-1/2 mt-4">
                                        <div className="space-y-4">
                                            <Investor 
                                                options={InvestorOptions}
                                                setOptions={setInvestorOptions}
                                                customPathname={customPathname}
                                                label="Investor"
                                                menu={menu}
                                            />

                                            <TargetCompany 
                                                options={TargetCompanyOptions}
                                                setOptions={setTargetCompanyOptions}
                                                customPathname={customPathname}
                                                label="Company"
                                                menu={menu}
                                            />

                                            <LAdvisor 
                                                options={lAdvisorsOptions}
                                                setOptions={setlAdvisorsOptions}
                                                customPathname={customPathname}
                                                label="Legal Advisors"
                                                menu={menu}
                                            />

                                            <TAdvisor 
                                                options={tAdvisorsOptions}
                                                setOptions={settAdvisorsOptions}
                                                label="Transaction Advisors"
                                                customPathname={customPathname}
                                                menu={menu}
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* No section selected */}
                                {!activeFilterSection && (
                                    <div className="flex items-center justify-center h-40 text-gray-500">
                                        <p>Select a filter category from the left to view available filters</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                </form>
            </div>
        </div>
    );
}

